// extracted by mini-css-extract-plugin
module.exports = {"footerSection":"Footer_footerSection__6yzb_","content":"Footer_content__ZW26M","links":"Footer_links__M7Bew","disclaimer":"Footer_disclaimer__DrOrB","logo":"Footer_logo__MIWgM"};